module.exports = __webpack_public_path__ + "files/d1b413f92f2ed0b72aad11ed16f9175f.png";